// lib
import { connect } from "react-redux";
// src
import Component from "components/plannings/table/partials/Toolbar";
import { refresh } from "actions/events";
import { updateRangeAndFetch } from "actions/events/thunks";
import { selfTranslate } from "i18n/proxy";

const mapStateToProps = ({ table: { focus, title, titleLink }, ux: { isLarge, language } }) => ({
  focus: new Date(focus),
  isLarge,
  selfTranslate: (name) => selfTranslate(name, language),
  title,
  titleLink,
});

const mapDispatchToProps = {
  refresh,
  updateRangeAndFetch,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
